import type { PaletteOptions } from '@mui/material/styles';

/**
 * Dark is the product default. A near-black ground with a slight blue cast, so elevation reads as a lift
 * rather than a glow; the primary blue carries over to the light theme so the two are recognisably one
 * product. Components never name a colour — they ask the theme (Conventions/06 §6).
 */
export const DARK_PALETTE: PaletteOptions = {
  mode: 'dark',
  primary: { main: '#6aa8f0', light: '#93c0f5', dark: '#3f7fd0', contrastText: '#0b0e12' },
  secondary: { main: '#e0a458', light: '#eec084', dark: '#b07f3c', contrastText: '#0b0e12' },
  success: { main: '#5fb98a' },
  warning: { main: '#e0a458' },
  error: { main: '#e5716b' },
  info: { main: '#6aa8d8' },
  background: { default: '#0f1216', paper: '#161a20' },
  divider: 'rgba(255, 255, 255, 0.09)',
  text: { primary: '#e4eaf1', secondary: '#93a0ae', disabled: '#5d6976' },
  action: {
    hover: 'rgba(255, 255, 255, 0.045)',
    selected: 'rgba(106, 168, 240, 0.14)',
    disabled: 'rgba(255, 255, 255, 0.26)',
    disabledBackground: 'rgba(255, 255, 255, 0.09)',
  },
};

export const LIGHT_PALETTE: PaletteOptions = {
  mode: 'light',
  primary: { main: '#2b5fa8', light: '#4f80c4', dark: '#1d447d', contrastText: '#ffffff' },
  secondary: { main: '#b3762a', light: '#cf9750', dark: '#8a5a1d', contrastText: '#ffffff' },
  success: { main: '#2f7d4f' },
  warning: { main: '#b7791f' },
  error: { main: '#b3413b' },
  info: { main: '#2f6a99' },
  background: { default: '#f5f6f8', paper: '#ffffff' },
  divider: 'rgba(15, 18, 22, 0.10)',
  text: { primary: '#171b20', secondary: '#5b6670', disabled: '#98a2ab' },
};
